import { render, staticRenderFns } from "./UserCover.vue?vue&type=template&id=17d20bde&"
import script from "./UserCover.vue?vue&type=script&lang=js&"
export * from "./UserCover.vue?vue&type=script&lang=js&"
import style0 from "./UserCover.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports